import { createRoute } from "@routes/utils";

import { notificationsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = "all";

const notificationsRouteMetadata: IRouteMetadataObj<
  typeof notificationsRoutesObj
> = {
  base: {
    title: "notifications.title",
    description: "empty",
    lazy: () => import("src/pages/notifications/page"),
    mode: "index",
    type: "inner",
    icon: "Notification3Line",
    breadcrumbs: [],
    permission,
  },
};

export const notificationsRoutes = createRoute<typeof notificationsRoutesObj>(
  notificationsRoutesObj,
  notificationsRouteMetadata,
);
